<template>
  <div>
    <div class="category-title">
      <h1 class="h1-like">
        {{ $t("dashboard.utm_title") }}
      </h1>
      <div class="action-block">
        <div class="item">
          <b-button
            class="bttn bttn--lg bttn--orange"
            :disabled="modalLoading"
            @click="openAddModal"
          >
            <b-spinner v-if="modalLoading" small class="mx-2"></b-spinner>
            {{ $t("dashboard.utm_add_new_source") }}
          </b-button>
          <b-button
            v-if="count"
            class="bttn bttn--lg bttn--orange mx-1"
            :disabled="exportLoading"
            @click="exportToFile"
          >
            <b-spinner v-if="exportLoading" variant="light" small class="mr-2" />
            {{ $t("dashboard.utm_add_export", "Export") }}
          </b-button>
        </div>
      </div>
    </div>

    <b-table
      head-variant="light"
      :busy="loading"
      :fixed="true"
      :items="items"
      :fields="fields"
      table-class="table-align-middle"
    >
      <template v-slot:table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template v-slot:cell(copy_url)="{ index, item }">
        <a
          class="copy-link"
          v-b-popover.hover.top="
            copied !== index
              ? item.attributes.result_url
              : $t('dashboard.utm_link_copied_to_clipboard')
          "
          @click="copy(index, item.attributes.result_url)"
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.40156 19.4896L16.6016 19.4896C16.8137 19.4896 17.0172 19.4054 17.1672 19.2554C17.3173 19.1055 17.4016 18.9021 17.4016 18.6901L17.4016 4.29948C17.4016 4.08744 17.3173 3.88409 17.1672 3.73416C17.0172 3.58423 16.8137 3.5 16.6016 3.5H7.80156C7.69702 3.50126 7.59374 3.52299 7.49756 3.56396C7.39865 3.60059 7.30866 3.65782 7.23356 3.73185L4.83356 6.13029C4.7616 6.20396 4.70456 6.29083 4.66556 6.38612C4.62526 6.48525 4.60356 6.59094 4.60156 6.69792V18.6901C4.60156 18.9021 4.68585 19.1055 4.83588 19.2554C4.98591 19.4054 5.18939 19.4896 5.40156 19.4896ZM8.60156 5.09896L15.8016 5.09896L15.8016 17.8906L6.20156 17.8906L6.20156 7.4974H7.80156C8.01374 7.4974 8.21722 7.41317 8.36725 7.26324C8.51728 7.1133 8.60156 6.90995 8.60156 6.69792V5.09896ZM18.5859 21.5L9.97426 21.4805C9.97426 21.4805 9.17188 21.4805 9.17188 20.6841C9.17188 19.8878 9.97426 19.8878 9.97426 19.8878H17.804L17.804 8.29687C17.804 8.29687 17.8016 7.49739 18.6016 7.49739C19.4016 7.49739 19.3984 8.29687 19.3984 8.29687L19.3984 20.6738C19.3984 20.8858 19.3258 21.0924 19.1758 21.2423C19.0258 21.3923 18.7981 21.5 18.5859 21.5Z"
              fill="#107598"
            />
          </svg>
          {{ $t("dashboard.utm_copy_url") }}
        </a>
      </template>
      <template v-slot:cell(actions)="{ item }">
        <b-dropdown variant="link" no-caret>
          <template v-slot:button-content>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 18.5C14 17.3954 13.1046 16.5 12 16.5C10.8954 16.5 10 17.3954 10 18.5C10 19.6046 10.8954 20.5 12 20.5C13.1046 20.5 14 19.6046 14 18.5Z"
                fill="#107598"
              />
              <path
                d="M14 12.5C14 11.3954 13.1046 10.5 12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5C13.1046 14.5 14 13.6046 14 12.5Z"
                fill="#107598"
              />
              <path
                d="M14 6.5C14 5.39543 13.1046 4.5 12 4.5C10.8954 4.5 10 5.39543 10 6.5C10 7.60457 10.8954 8.5 12 8.5C13.1046 8.5 14 7.60457 14 6.5Z"
                fill="#107598"
              />
            </svg>
          </template>
          <b-dropdown-item-button :disabled="modalLoading" @click="openEditModal(item)">
            <b-spinner v-if="modalLoading" small class="mx-2"></b-spinner>
            {{ $t("dashboard.utm_actions_edit") }}
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="removeItem(item)">
            <span class="text-danger">
              {{ $t("dashboard.utm_actions_delete") }}
            </span>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>

    <div v-if="count >= per_page" class="pagination">
      <b-pagination v-model="page" :total-rows="count" :per-page="per_page" size="md">
      </b-pagination>
    </div>

    <utm-link-form-modal :page="page" :per-page="per_page" ref="utmFormModal" />
  </div>
</template>

<script>
import { notificationsMixin } from "@/mixins";
import { mapActions, mapState } from "vuex";

import UtmLinkFormModal from "./UTMLinkFormModal.vue";
import axios from "axios";
import urls from "@/constants/urls";
import { mapCampaignIncludedToRelationships } from "@/helpers/jsonapi";

export default {
  components: {
    UtmLinkFormModal,
  },

  mixins: [notificationsMixin],

  data() {
    return {
      fields: [
        {
          key: "attributes.medium",
          label: this.$t("dashboard.utm_th_medium"),
        },
        {
          key: "attributes.source",
          label: this.$t("dashboard.utm_th_source"),
        },
        {
          key: "attributes.campaign",
          label: this.$t("dashboard.utm_th_campaign"),
        },
        {
          key: "attributes.content",
          label: this.$t("dashboard.utm_th_content"),
        },
        {
          key: "attributes.term",
          label: this.$t("dashboard.utm_th_term"),
        },
        {
          key: "attributes.destination_url",
          label: this.$t("dashboard.utm_th_destination_url"),
        },
        {
          key: "copy_url",
          label: this.$t("dashboard.utm_th_result_url"),
        },
        {
          key: "actions",
          label: this.$t("dashboard.utm_th_actions", "Actions"),
        },
      ],
      copied: "",
      page: 1,
      per_page: 20,
      exportLoading: false,
      modalLoading: false,
    };
  },

  computed: {
    ...mapState({
      cmpId: (state) => state.tools.campaign?.id,
      items: (state) => state.tools.utm.list,
      count: (state) => Number(state.tools.utm.count),
      loading: (state) => state.tools.utm.loading,
    }),
  },

  watch: {
    cmpId(val) {
      if (val) {
        this.page = 1;
        this.getUTMs();
      }
    },

    page() {
      this.getUTMs();
    },
  },

  mounted() {
    if (this.cmpId) {
      this.getUTMs();
    }
  },

  methods: {
    ...mapActions({
      fetchUTMs: "tools/utm/fetchUTMs",
      fetchDeleteUTM: "tools/utm/fetchDeleteUTM",
      fetchExportUTM: "tools/utm/fetchExportUTM",
    }),

    getUTMs() {
      const params = {
        page: this.page,
        per_page: this.per_page,
      };
      this.fetchUTMs([this.cmpId, params]);
    },

    copy(i, text) {
      const dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.copied = i;
    },

    async openAddModal() {
      this.modalLoading = true;

      try {
        const campaign = await this.getCampaignData();
        console.log(campaign);
        this.$refs.utmFormModal.open("add", null, campaign);
      } catch (e) {
        this.$_notificationsMixin_handleCatch(e);
        return;
      } finally {
        this.modalLoading = false;
      }
    },

    exportToFile() {
      this.exportLoading = true;
      this.fetchExportUTM([this.cmpId])
        .then(({ data }) => {
          const l = data.data.link;
          const a = document.createElement("a");
          a.href = l;
          a.target = "_blank";

          a.click();
          a.remove();
          this.exportLoading = false;
        })
        .catch(this.$_notificationsMixin_fillWithErrors);
    },

    async getCampaignData() {
      const orgID = localStorage.getItem("orgId");

      try {
        const { data } = await axios.get(
          urls.getCampaignData.replace(":orgId", orgID).replace(":campaignId", this.cmpId),
          {
            params: {
              extend: [
                "campaign_stats",
                "media",
                "meta",
                "donation_levels",
                "donation_streams",
                "url_alias",
              ],
            },
            paramsSerializer: {
              indexes: null, // no brackets at all
            },
          }
        );

        return mapCampaignIncludedToRelationships(data.data, data.included);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async openEditModal(item) {
      this.modalLoading = true;

      try {
        const campaign = await this.getCampaignData();
        const iCopy = JSON.parse(JSON.stringify(item));
        this.$refs.utmFormModal.open("edit", iCopy, campaign);
      } catch (e) {
        this.$_notificationsMixin_handleCatch(e);
        return;
      } finally {
        this.modalLoading = false;
      }
    },

    removeItem(item) {
      let message = this.$t("dashboard.utm_confirm_delete_msg");

      let options = {
        okText: this.$t("dashboard.utm_confirm_delete_ok_btn"),
        cancelText: this.$t("dashboard.cancel_btn"),
      };

      this.$dialog.confirm(message, options).then(() => {
        this.fetchDeleteUTM([this.cmpId, item.id]).then(() => {
          this.getUTMs();
          this.$_notificationsMixin_makeToast(
            "Success!",
            this.$t("dashboard.utm_link_success_delete", "Deleted successfully"),
            "success"
          );
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-link {
  cursor: pointer;
}

.table thead th {
}
.table th {
}
</style>
